import { Signature } from "@type/core/dashboard/dashboard.types";
import { FunctionComponent, useEffect, useState } from "react";

import BasicModal from "@components/core/modals/BasicModal";
import { getUserConsent, postUserConsent } from "@state/users/UserEffects";
import { toastError } from "@utils/helpers/toast-helper";
import { useTranslation } from "react-i18next";
import SignatureHelper from "@utils/helpers/signature-helper";
import { Consent } from "@type/core/qcp/qcp.types";

interface ConsentModalProps {
  signatures: Signature[];
}

const ConsentModal: FunctionComponent<ConsentModalProps> = ({ signatures }) => {
  const { t } = useTranslation();

  const [consentModalVisible, setConsentModalVisible] =
    useState<boolean>(false);
  const [consent, setConsent] = useState<Consent>();
  useEffect(() => {
    const atLeaseOneMultipleSignature =
      signatures.filter(
        (signature) =>
          signature.identificator &&
          SignatureHelper.getSignatureIndexFromIdentificator(
            signature.identificator ?? "",
          ) >= 2,
      ).length > 0;

    if (
      atLeaseOneMultipleSignature &&
      !consentModalVisible &&
      consent &&
      !consent.multiSignature
    ) {
      setConsentModalVisible(true);
    }
  }, [signatures]);

  const handleAcceptMultipleSignatures = async () => {
    await postUserConsent({ dto: { multiSignature: true } }).catch(() =>
      toastError(t("error.toast.allowMultipleSignature")),
    );
    setConsentModalVisible(false);
    await getUserConsent({});
  };

  useEffect(() => {
    void getUserConsent({});
  }, []);

  useEffect(() => {
    return getUserConsent.done.watch(({ result }) => {
      if (result.ok && result.data) {
        setConsent(result.data);
      } else {
        toastError(t("error.retrieveConsent"));
      }
    });
  });

  return (
    <BasicModal
      title={t("modals.info.allowMultipleSignature.title")}
      visible={consentModalVisible}
      onOk={() => void handleAcceptMultipleSignatures()}
      onCancel={() => setConsentModalVisible(false)}
      showCancelButton={false}
      buttonText={t("modals.info.allowMultipleSignature.validateButton")}
      footerTakeAllWidth={true}
      className={"white-space-pre-line"}
    >
      {t("modals.info.allowMultipleSignature.body")}
    </BasicModal>
  );
};

export default ConsentModal;
